<template>
    <div class="flex flex-center-sp">
        <div class="invite-body flex flex-col">
            <div class="font-bold font-l margin-top-xxl">专属邀请链接</div>
            <div class="flex flex-center-cz margin-top-m">
                <input class="h25 border" type="text" value="http://dalunzi.com/doc/123" style="width: 400px;" readonly/>
                <div class="btn-blue-full margin-left-m h25 border-radius-l">复制链接</div>
            </div>
            <div class="font-bold font-m margin-top-xxl">通过您的专属链接注册后，ta可以获取30天高级版时长，您可以</div>
            <div class="font-m margin-top-m">1、获得最多365天会员时长</div>
            <div class="font-m margin-top-m">2、好友首次购买高级版时，您将额外获得30天高级会员</div>
            <div class="font-m margin-top-m">3、非法刷量获得会员，账号将被封禁</div>
            <div class="font-bold font-l margin-top-xxl">奖励路径</div>
            <div class="flex margin-top-m">
                <div class="invite-card flex flex-col flex-center-cz">
                    <img class="margin-top-xxl" style="width: 30px;height: 30px;margin-top: 20px;" src="@/assets/images/benyue.png"/>
                    <div class="font-m font-bold margin-top-m">月卡</div>
                    <div class="font-s margin-top-s color-rgb-05">再邀请3人解锁</div>                   
                </div>
                <div class="invite-card flex flex-col flex-center-cz">
                    <img class="margin-top-xxl" style="width: 45px;height: 45px;margin-top: 15px;" src="@/assets/images/jidu.png"/>
                    <div class="font-m font-bold margin-top-s">季卡</div>
                    <div class="font-s margin-top-s color-rgb-05">再邀请5人解锁</div>                   
                </div>
                <div class="invite-card flex flex-col flex-center-cz">
                    <img class="margin-top-xxl" style="width: 45px;height: 45px;margin-top: 15px;" src="@/assets/images/halfyear.png"/>
                    <div class="font-m font-bold margin-top-s">半年卡</div>
                    <div class="font-s margin-top-s color-rgb-05">再邀请12人解锁</div>                  
                </div>
                <div class="invite-card flex flex-col flex-center-cz">
                    <img class="margin-top-xxl" style="width: 45px;height: 45px;margin-top: 15px;" src="@/assets/images/yearcard.png"/>
                    <div class="font-m font-bold margin-top-s">年卡</div>
                    <div class="font-s margin-top-s color-rgb-05">再邀请20人解锁</div>                 
                </div>
            </div>
            <div class="font-m margin-top-l color-rgb-05">只须邀请3人，即可获得30天高级会员</div>
            
            <div class="font-bold font-l margin-top-xxl">赠送记录</div>
            <div class="font-m margin-top-l color-rgb-05">您还没有赠送记录，赶快邀请好友使用量子文档吧，还能获取相应的奖励哦</div>


        </div>
        
    </div>

</template>

<script>
 export default {
    name:'Invite'
 }
    

</script>

<style scoped>
  .invite-body {
    width: 750px;
    margin-top: 60px;
    min-height: 500px;
  }
  .invite-card {

    width: 180px;
  }

  





</style>


// WEBPACK FOOTER //
// src/views/Invite.vue